<div class="profile-info">
  <ion-label position="stacked">{{ label }}</ion-label>

  <div class="profile-inputs">
    <img [src]="selectedFlag" alt="Bandera" class="flag" />

    <ion-select
      name="countryCode"
      interface="popover"
      [(ngModel)]="countryCode"
      (ionChange)="onCountryChange()"
      [selectedText]="getSelectedCountryText()"
    >
      <ion-select-option
        *ngFor="let phoneNumber of phoneNumbers"
        [value]="phoneNumber.country"
      >
        <div class="select-flag">
          <img [src]="phoneNumber.flag" alt="Bandera" class="flagupdate" />
          <span>{{ phoneNumber.code }} - {{ phoneNumber.text }}</span>
        </div>
      </ion-select-option>
    </ion-select>

    <ion-input
      name="tel"
      type="tel"
      minlength="8"
      maxlength="15"
      [(ngModel)]="tel"
      (ionInput)="parsePhoneNumber($event)"
      (ionInput)="onPhoneInput($event)"
      [placeholder]="placeholder || 'Seleccione una opción'"
    >
    </ion-input>
  </div>
</div>
